var React = require('react')
var Link = require('react-router').Link

var Navigation = require('../Navigation/Navigation')

var Home = React.createClass({

  render() {
    return (<div className=''>
        <Navigation {...this.props} />
        <div className='col-margin-top col-md-12'>
            {this.props.children}
        </div>
        <div id="footer">
            <img src="css/Heder-01.png"/>
            <p className="futerp1"> © Copyright Termovent SC Livnica čelika A.D. Bačka Topola</p>

        </div>
      </div>)
  }
})

module.exports = Home;



/** WEBPACK FOOTER **
 ** ./modules/components/App/App.js
 **/